<script>
import { mapState } from 'vuex'
import Progress from '@components/progress'
import deepLink from '@/mixins/deeplink.js'
// import FinishedTimerModal from '@components/modals/finished-timer-modal'

const IOS_DEVICE_OS = 'iOS'

export default {
  name: 'Timer',
  components: { Progress },
  mixins: [deepLink()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      time: 0,
      initTime: 0,
      timeOver: false,
      countDownInterval: null,
    }
  },
  computed: {
    ...mapState('widgets', {
      userOS: state => state.common.user.os,
    }),
    progressValue: function() {
      const value = this.time / this.initTime
      return Math.trunc(value * 100)
    },
    textValue: function() {
      let minutes = Math.trunc(this.time / 60)
      let seconds = this.time - minutes * 60
      minutes = ('0' + minutes).substr(-2)
      seconds = ('0' + seconds).substr(-2)
      return `${minutes}:${seconds}`
    },
    deeplink() {
      const { userOS } = this
      return userOS === IOS_DEVICE_OS ? 'goto=home' : 'goto=help_center'
    },
  },
  watch: {
    timeOver: 'emitTimeOver',
  },
  created() {
    this.initTime =
      this.componentData.timeSeconds ||
      this.minutesToSeconds(this.componentData.time)
    this.time =
      this.componentData.leftTimeSeconds ||
      this.minutesToSeconds(this.componentData.leftTime)

    this.doCountDown()
  },
  methods: {
    doCountDown() {
      this.countDownInterval = setInterval(
        function() {
          this.decreaseTime()
        }.bind(this),
        1000
      )
    },
    decreaseTime() {
      return this.time > 0
        ? (this.time = this.time - 1)
        : (this.timeOver = true)
    },
    emitTimeOver() {
      clearInterval(this.countDownInterval)
      this.callDeepLink('goto=home')
    },
    minutesToSeconds: function(minutes) {
      return parseInt(minutes) * 60
    },
  },
}
</script>

<template>
  <div
    class="container"
  >
    <div class="container__text">
      <h4
        align="left"
        class="container__header"
      >
        {{ $t('WIDGETS.TIMER.IMMEDIATE_HELP') }}
      </h4>
      <p
        align="left"
        lang="es"
        class="container__paragraph"
      >{{ $t('WIDGETS.TIMER.IN_THE_NEXT') }} {{ componentData.time }} {{ $t('WIDGETS.TIMER.MINUTES_OPEN_ORDER') }}</p>
    </div>
    <Progress
      :value="progressValue"
      :textValue="textValue"
    />
    <v-dialog/>
  </div>
</template>


<style scoped lang="scss">
@import '@design';

.container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  margin: 0 1rem 2rem 1rem;
  background-color: $white;
  border-radius: 8px;
  box-shadow: $regular-box-shadow;

  &__text {
    padding: 1rem;
  }

  &__header {
    align-self: flex-start;
    width: 100%;
    margin: 0 0 0.75rem 0;
    font-weight: bold;
    color: $charcoal-gray;

    @extend %typography-large;
  }

  &__paragraph {
    hyphens: auto;
    line-height: 1.2;
    color: $charcoal-gray;
    text-align: justify;

    @extend %typography-small;
  }
}
</style>
